import request from '@/utils/request.js'
import { download } from '../utils/request'

export async function getInformation(params) {
  return request({
    url: '/api/public/event/registration',
    method: 'get',
    params,
  })
}

export async function getColleague(data, params) {
  return request({
    url: '/api/public/event/registration/colleague',
    method: 'get',
    params,
  })
}

export async function sent(data, params) {
  return request({
    url: '/api/public/event/registration/sent',
    method: 'post',
    data,
    params,
  })
}

export async function personal(data, params) {
  return request({
    url: '/api/public/event/registration/personal',
    method: 'post',
    data,
    params,
  })
}

export async function survey(data, params) {
  return request({
    url: '/api/public/event/registration/survey',
    method: 'post',
    data,
    params,
  })
}


export async function colleague(data, params) {
  return request({
    url: '/api/public/event/registration/colleague',
    method: 'post',
    data,
    params,
  })
}


export async function ticket(data, params) {
  return request({
    url: '/api/public/event/registration/ticket',
    method: 'post',
    data,
    params,
  })
}

export async function getOrderList(params) {
  return request({
    url: '/api/public/event/registration/order',
    method: 'get',
    params,
  })
}

export async function cancelOrder(id, params) {
  return request({
    url: '/api/public/event/registration/order/cancel/' + id,
    method: 'post',
    data: {},
    params,
  })
}

export async function discount(data, params) {
  return request({
    url: `/api/public/event/registration/order/discount`,
    method: 'post',
    data: data,
    params,
  })
}

export async function createOrder(data, params) {
  return request({
    url: '/api/public/event/registration/order',
    method: 'post',
    data: data,
    params,
  })
}

export async function payment(params) {
  return request({
    url: `/api/public/event/registration/payment`,
    method: 'post',
    data: {},
    params,
  })
}

export async function confirmation(params) {
  return request({
    url: `/api/public/event/registration/confirmation`,
    method: 'post',
    data: {},
    params,
  })
}


export async function getConfirmation(params) {
  return request({
    url: `/api/public/event/registration/confirmation`,
    method: 'get',
    params,
  })
}

export async function login(data, params) {
  return request({
    url: '/api/public/event/registration/login',
    method: 'post',
    data,
    params,
  })
}


export async function getReceipt( params) {
  return download({
    url: '/api/public/event/registration/receipt',
    method: 'get',
    params,
  })
}

export async function getInovice( params) {
  return request({
    url: '/api/public/event/registration/inovice',
    method: 'get',
    params,
  })
}



export async function updateInovice(data, params) {
  return request({
    url: '/api/public/event/registration/inovice',
    method: 'post',
    data,
    params,
  })
}
